/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
// import moment from "moment/moment";
import moment from "moment/moment";
import InputField from "../../../components/common/new/InputField/InputField";
import { isEmptyObj } from "../../../utils/helper";
import Styles from "../../Reports/GohonzonReports/GohonzonSearch.styles";
import useParamsQuery from "../../../hooks/useParamsQuery";
import DateRangePicker from "../../../components/common/DateRangePicker/DateRangePicker";
import DropDownSelect from "../../../components/common/Dropdown";

const initialFormValue = {
  applicationFrom: moment()
    .startOf("month")
    .add(1, "days")
    .format("YYYY-MM-DD"),
  applicationTo: moment().endOf("month").add(1, "days").format("YYYY-MM-DD"),
  allotmentFrom: "",
  allotmentTo: "",
  conferredFrom: "",
  conferredTo: "",
};

const gohonzonTypeOptions = [
  { entityTitle: "Okataki gohonzon", value: "OKATAKI_GOHONZON" },
  { entityTitle: "Omamori gohonzon", value: "OMAMORI_GOHONZON" },
];

function PersonalDetailsSearch() {
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [selectedGohonzonTypes, setSelectedGohonzonTypes] = useState([]);
  const [memberId, setMemberId] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      Object.keys(initialFormValue).forEach((key) => {
        setInitialAdvanceFormValue((prev) => ({
          ...prev,
          [key]: query[key] ?? "",
        }));
      });
    } else {
      setInitialAdvanceFormValue(initialFormValue);
    }
  }, [urlSearchParams.toString()]);

  const startDateValue = memberId
    ? moment("2020-01-01").format("YYYY-MM-DD")
    : initialAdvanceFormValue.applicationFrom;

  return (
    <Box>
      <Box sx={{ width: "100%" }}>
        <Grid container rowSpacing={4} columnSpacing={5}>
          <Grid item xs={6}>
            <InputField
              label="Member ID"
              name="memberId"
              onChange={(e) => setMemberId(e.target.value)}
              style={Styles.textfieldStyle}
            />
          </Grid>
          <Grid item xs={6}>
            <InputField
              label="Member Name"
              name="fullName"
              style={Styles.textfieldStyle}
            />
          </Grid>

          <Grid item xs={6}>
            <DropDownSelect
              title="Gohonzon Type"
              name="type"
              selectOptions={gohonzonTypeOptions}
              value={selectedGohonzonTypes}
              setValue={setSelectedGohonzonTypes}
              style={{ width: "90%" }}
            />
          </Grid>
          <Grid item xs={6}>
            <DateRangePicker
              label="Application Date"
              name="application"
              startDateVal={startDateValue}
              endDateVal={initialAdvanceFormValue.applicationTo}
            />
          </Grid>
          {/* <Grid item xs={6}>
            <DateRangePicker
              label="Allotment Date"
              name="allotment"
              startDateVal={initialAdvanceFormValue.allotmentFrom}
              endDateVal={initialAdvanceFormValue.allotmentTo}
            />
          </Grid>
          <Grid item xs={6}>
            <DateRangePicker
              label="Conferral Date"
              name="conferred"
              startDateVal={initialAdvanceFormValue.conferredFrom}
              endDateVal={initialAdvanceFormValue.conferredTo}
            />
          </Grid> */}
        </Grid>
      </Box>
      <Grid item md={8} sm={12} spacing={2} />
    </Box>
  );
}

export default PersonalDetailsSearch;
